import {AbstractFilterComponent} from "../abstract-filter-component.js";
import {FilterCheckbox} from './checkbox.js';

export class FilterParentingCheckboxGroup extends AbstractFilterComponent {

	parentCheckbox;
	childrenCheckboxes = [];

	constructor(parent, filter, node, children) {
		super(parent, filter, node);
		this.initChildren(children);
	}

	initChildren(children) {
		let self = this;

		self.parentCheckbox = new FilterCheckbox(self, self.filter, self.node);
		self.childrenCheckboxes = children.map(checkbox => {
			let input = new FilterCheckbox(self, self.filter, checkbox);

			if (self.parentCheckbox.isChecked()) {
				input.setCheckedState(true, false);
			}

			return input;
		});

		if (! self.childrenCheckboxes.length) {
			return;
		}

		if (self.areAllChildrenChecked()) {
			self.parentCheckbox.setCheckedState(true, false);

			return;
		}

		if (self.isAnyChildChecked()) {
			self.parentCheckbox.setIndeterminateState(true, false);
		}
	}

	childComponentChangedState(child) {
		let self = this;

		// parent update
		if (child === self.parentCheckbox) {
			self.childrenCheckboxes.forEach(checkbox => {
				checkbox.setCheckedState(self.parentCheckbox.isChecked(), false);
			});

			return self.componentStateChanged();
		}

		// child update - all
		if (self.areAllChildrenChecked()) {
			self.parentCheckbox.setCheckedState(true, false);

			return self.componentStateChanged();
		}

		// child update - a few
		if (self.isAnyChildChecked()) {
			self.parentCheckbox.setIndeterminateState(true, false);

			return self.componentStateChanged();
		}

		// child update - none
		self.parentCheckbox.setCheckedState(false, false);

		return self.componentStateChanged();
	}

	areAllChildrenChecked() {
		let self = this;

		return ! self.childrenCheckboxes.length || self.getCheckedChildren().length === self.childrenCheckboxes.length;
	}

	isAnyChildChecked() {
		let self = this;

		return self.childrenCheckboxes.length === 0 || self.getCheckedChildren().length > 0;
	}

	getCheckedChildren() {
		let self = this;

		return self.childrenCheckboxes.filter(checkbox => {
			return checkbox.isChecked();
		});
	}

	setCheckedState(state) {
		let self = this;

		self.childrenCheckboxes.forEach(checkbox => {
			checkbox.setCheckedState(state, false);
		});

		self.parentCheckbox.setIndeterminateState(false, false);
		self.parentCheckbox.setCheckedState(state, false);

		return self.componentStateChanged();
	}

	getLabels() {
		let self = this;

		if (self.parentCheckbox.isChecked()) {
			return [
				self.parentCheckbox.getLabel(),
			];
		}

		return self.getCheckedChildren().map(children => {
			return children.getLabel();
		});
	}

	getFormData() {
		let self = this;
		let data = {};

		if (self.parentCheckbox.isChecked()) {
			data[self.parentCheckbox.getName()] = self.parentCheckbox.getValue();

			return data;
		}

		self.getCheckedChildren().forEach(children => {
			data[children.getName()] = children.getValue();
		});

		return data;
	}
}
